import axios from '@/utils/api'

const actions = {
  async getProcessosReurb () {
    const data = await axios({
      method: 'GET',
      url: 'reurb/relatorio/cards'
    })

    return data
  },

  async getOSReurb () {
    const data = await axios({
      method: 'GET',
      url: 'ordemServico/reurb/'
    })

    return data
  },

  async getMunicipios () {
    const data = await axios({
      method: 'GET',
      url: 'relatorios/processos/processosByMunicipio'
    })

    return data
  },

  async getReurbDataByFilter ({ commit }, filtro) {
    const data = await axios({
      method: 'POST',
      url: 'reurb/relatorio/findByFilter',
      data: filtro
    })

    return data
  },

  async getProcessosReurbByFilter ({ commit }, filtro) {
    const data = await axios({
      method: 'POST',
      url: 'processo/findByFilterReurb',
      data: filtro
    })

    return data
  },

  async exportaCSVCadastro ({ commit }, filtro) {
    const file = await axios({
      method: 'POST',
      url: 'reurb/relatorio/csv',
      data: filtro,
      responseType: 'blob'
    })

    return file
  },

  async exportaCSVProcesso ({ commit }, filtro) {
    const file = await axios({
      method: 'POST',
      url: 'processo/reurb/csv',
      data: filtro,
      responseType: 'blob'
    })

    return file
  },

  async exportarGeorreferenciamento ({ commit }, filtro) {
    const file = await axios({
      method: 'POST',
      url: 'processo/reurb/exportarGeorreferenciamento',
      data: filtro,
      responseType: 'blob',
      loader: false
    })

    return file
  },

  async exportaCSVCRF ({ commit }, numerosProcesso) {
    const file = await axios({
      method: 'POST',
      url: 'processo/reurb/crf',
      data: numerosProcesso,
      responseType: 'blob'
    })

    return file
  },

  async getCadastrantesReurb ({ commit }, filtro) {
    const data = await axios({
      method: 'GET',
      url: `reurb/relatorio/cadastrantes/${filtro}`
    })

    return data
  },

  async getPerfis () {
    const data = await axios({
      method: 'GET',
      url: 'publico/perfil/perfisReurb'
    })

    return data
  },

  async getZipRelatoriosReurb ({ commit }, filtro) {
    const data = await axios({
      method: 'POST',
      url: 'reurb/relatorio/generateZipAndSendEmail',
      loader: false,
      data: filtro
    })

    return data
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/relatorios_reurb/relatoriosReurb.js